import { Play } from 'lucide-react';

interface TenantPortalVideoPlaceholderProps {
  label: string;
  sublabel?: string;
  aspectClass?: string;
  className?: string;
}

/**
 * Static video slot before CMS content is uploaded (move-out "Coming soon" pattern).
 */
export default function TenantPortalVideoPlaceholder({
  label,
  sublabel = 'Video coming soon',
  aspectClass = 'aspect-video',
  className = '',
}: TenantPortalVideoPlaceholderProps) {
  return (
    <div
      className={`overflow-hidden rounded-xl border border-gray-200 bg-gray-900 ${className}`.trim()}
    >
      <div className={`relative flex w-full items-center justify-center ${aspectClass}`}>
        <div className="text-center px-6">
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-white/10 ring-1 ring-white/20">
            <Play className="h-7 w-7 text-white/80" aria-hidden="true" />
          </div>
          <p className="text-sm font-medium text-white/80">{label}</p>
          <p className="mt-1 text-xs text-white/45">{sublabel}</p>
        </div>
      </div>
    </div>
  );
}
